import * as React from 'react';
import { FixBodyUtil } from '~/utils/fix-body';

import './style.scss';

const PREFIX = 'ui-mobile-drawer';

export interface DrawerProps {
  /** 方向，默认是'bottom-top' */
  direction?: string;
  /** 组件是否可见 */
  isOpen: boolean;
  /** 关闭回调 */
  onClose?: () => void;
  /** 面板的标题，若无title则不显示header区域，可以自定义组件 */
  title?: any;
  /** 内容 */
  children: any;
  /** 遮罩层是否可以点击关闭，默认true */
  maskClosable?: boolean;
  /** 容器类名 */
  className?: string;
  /** 是否显示遮罩层 */
  showMask?: boolean;
}

export class Drawer extends React.Component<DrawerProps> {
  static defaultProps = {
    direction: 'bottom-top',
    onClose: () => {},
    showBack: true,
    title: '',
    maskClosable: true,
    className: '',
    showMask: true,
  };
  savedTop!: number;
  componentDidMount() {
    this.savedTop = window.scrollY;
    if (this.props.isOpen) {
      this.toggleBodyFixed(true);
    }
  }

  componentDidUpdate(prevProps: DrawerProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.toggleBodyFixed(this.props.isOpen);
    }
  }

  componentWillUnmount() {
    // fix: spa在drawer打开时进行路由跳转，不会触发消除body上的class
    if (this.props.isOpen) {
      this.toggleBodyFixed(false);
    }
  }

  toggleBodyFixed = (isOpen: boolean) => {
    if (isOpen) {
      this.savedTop = window.scrollY;
    }
    if (isOpen) {
      FixBodyUtil.fix();
    } else {
      FixBodyUtil.restore();
    }
  };

  onClose = () => {
    const { onClose } = this.props;
    onClose!();
    this.toggleBodyFixed(false);
  };
  render() {
    const { title, children, direction, maskClosable, isOpen, className, showMask } = this.props;
    return (
      <div className={`${PREFIX}-container ${isOpen ? 'open' : 'close'} ${direction} ${className}`}>
        {showMask && <div className={`${PREFIX}-mask`} onClick={maskClosable ? this.onClose : () => {}} />}
        <div className={`${PREFIX}-body`}>
          {title && (
            <div className={`${PREFIX}-header-container`}>
              <h4 className={`${PREFIX}-title`}>{title}</h4>
            </div>
          )}
          <div className={`${PREFIX}-content`}>{children}</div>
        </div>
      </div>
    );
  }
}
